import React from "react";
import { Box, IconButton, Paper, Stack, Typography } from "@mui/material";
import { X } from "@phosphor-icons/react";
import { theme } from "@answersnow/pkg-theme";

interface DrawerShellProps {
  title?: string;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
  onClose?: () => void;
  children: React.ReactNode;
  bodyPadding?: number | string;
}

const DrawerShell: React.FC<DrawerShellProps> = ({
  title,
  icon,
  actions,
  onClose,
  children,
  bodyPadding = "24px",
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        height: "100%",
        minHeight: 0,
        borderRadius: { xs: 0, md: theme.radius["ex-large"] },
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "background.paper",
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          px: 7,
          py: 5,
          flexShrink: 0,
        }}
      >
        {(title || icon) && (
          <Stack direction="row" alignItems="center" gap={3} flex={1} minWidth={0}>
            {icon}
            {title && (
              <Typography
                variant="h6"
                sx={{
                  fontSize: 24,
                  fontWeight: 500,
                  letterSpacing: 0.2,
                }}
              >
                {title}
              </Typography>
            )}
          </Stack>
        )}

        <Box gap={3} display="flex" alignItems="center" sx={{ ml: icon || title ? 2 : 0 }}>
          {actions}
          {onClose && (
            <IconButton
              onClick={onClose}
              size="small"
              sx={{ padding: "5px", borderRadius: theme.radius.button.sm }}
              aria-label="Close"
            >
              <X size={20} />
            </IconButton>
          )}
        </Box>
      </Stack>

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: "auto",
          backgroundColor: "background.paper",
          p: bodyPadding,
        }}
      >
        {children}
      </Box>
    </Paper>
  );
};

export default DrawerShell;